import { memo } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Typography } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';

const useStyles = makeStyles({ name: 'PrivateShowBar' })((theme) => ({
  root: {
    width: '100%',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    backgroundColor: theme.palette.info.light,
  },
  lockIcon: {
    marginRight: theme.spacing(1),
  },
}));

export const PrivateShowBar = memo(({
  className = '',
  ...restProps
}) => {
  const { classes, cx } = useStyles();

  return (
    <div
      className={cx(classes.root, className)}
      {...restProps}
    >
      <Typography variant="body2">
        <LockIcon className={classes.lockIcon} />

        <span>
          Private Show
        </span>
      </Typography>
    </div>
  );
});
